import * as Sentry from "@sentry/react-native";
import axios from "axios";
import { z } from "zod";
import type { RootStoreInstance } from "~/mobx/RootStore";
import type { AxiosRequestHeaders, InternalAxiosRequestConfig } from "axios";

export function createCheckAndRefreshTokenInterceptor(
  getStore: () => RootStoreInstance,
) {
  return async function checkAndRefreshToken(
    config: InternalAxiosRequestConfig,
  ) {
    try {
      const store = getStore();

      const accessToken = await store.authStore.updateTokens();

      if (!accessToken) {
        console.warn("🛑 No access token available, canceling request...");
        throw new axios.Cancel("Request canceled: No access token available.");
      }

      if (accessToken) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${accessToken}`,
        } as AxiosRequestHeaders;
      }
    } catch (error) {
      console.error("🛑 Error in token refresh interceptor:", error);

      const errorResponseSchema = z.object({ code: z.string() });
      const parsed = errorResponseSchema.safeParse(error);

      // Probably refresh token is expired (see Absolute refresh token lifetime in signicat settings)
      // we don't want to log this error to Sentry
      const isInvalidGrant =
        parsed.success && parsed.data.code === "invalid_grant";

      if (!isInvalidGrant) {
        Sentry.captureException(error);
      }

      throw new axios.Cancel(
        "Request canceled: Error in token refresh interceptor.",
      );
    }

    return config;
  };
}
